import { Box, HStack, Center, Text } from '@chakra-ui/react'
import { useState } from 'react'
import { FaArrowLeft, FaArrowRight }from 'react-icons/fa' 
import { projects } from '../../assets/projects'
import { ButtonPrimary } from '../ButtonPrimary/index'
import { ButtonSecondary } from '../ButtonSecondary/index'
export const Carousel = () =>{

    const [currentProject, setCurrentProject ] = useState(0)

    const handleClickPlus = () =>{
        if (currentProject+1 === projects.length) { 
            setCurrentProject(0)
        } else {
            setCurrentProject(currentProject+1)
        }
    }


    const handleClickLeft= () =>{
        if (currentProject === 0) {
            setCurrentProject(projects.length - 1)
        } else {
            setCurrentProject(currentProject-1)
        }
    }
    return(
        <Box mb={["0","0", "200px","200px"]}>
            <HStack>
                <Center
                    bg="blue.200"
                    w="50px"
                    h="50px"
                    cursor="pointer"
                    _hover={{
                        bg:"blue.300"
                    }}
                    onClick={ handleClickLeft }
                >
                    <FaArrowLeft/>
                </Center>
                <Text fontWeight="bold">0{ currentProject+1 }/0{ projects.length }</Text>
                <Center
                    bg="blue.200"
                    w="50px"
                    h="50px"
                    cursor="pointer"
                    _hover={{
                        bg:"blue.300"
                    }}
                    onClick={ handleClickPlus }

                >
                    <FaArrowRight/>
                </Center>
            </HStack >
            <Box display="flex" flexDir="column" mt="10">
                <Text 
                    as="h2"
                    fontSize="4xl"
                    fontWeight="bold"
                >
                    { projects[currentProject].name }
                </Text>
                <Text 
                    w={["300px", "300px", "500px", "500px"]}
                    color="gray.300"
                    mb="2"
                    minH="200px"
                >
                    { projects[currentProject].description }
                </Text> 
                <Text 
                    w={["300px", "300px", "500px", "500px"]}
                    color="gray.300"
                    mb="2"
                >
                   <Text fontWeight="bold">Principais Tecnologias:</Text> { projects[currentProject].technology }
                </Text>
                <HStack mt="10">
                    {
                    projects[currentProject].hasApplication &&
                    <ButtonPrimary isExternal href={projects[currentProject].aplicationLink}>
                      <Text>Aplicação</Text>
                    </ButtonPrimary>
                    }
                    <ButtonSecondary isExternal href={projects[currentProject].repository}>
                      <Text>Repositório</Text>
                    </ButtonSecondary>
                </HStack>
            </Box>
        </Box>
    )
}